import React from "react";
import { notification } from "antd";
import { enmPropertyType } from "../entityManager/interfaces";
import { ICallOptions, IResult } from "./models";

class TCore {
    isTestEnvironment?: boolean;
    isDevelopement?: boolean;
    operators: { [op: number]: { title: string; types: Array<enmPropertyType>; }; };
    constructor() {
        this.operators = {
            0: {
                title: "مساوی با",
                types: [
                    enmPropertyType.number,
                    enmPropertyType.boolean,
                    enmPropertyType.date,
                    enmPropertyType.datetime,
                    enmPropertyType.time,
                    enmPropertyType.string
                ]
            },
            1: {
                title: "نا مساوی با",
                types: [
                    enmPropertyType.boolean,
                    enmPropertyType.date,
                    enmPropertyType.datetime,
                    enmPropertyType.time,
                    enmPropertyType.string
                ]
            },
            2: {
                title: "کوچکتر از",
                types: [
                    enmPropertyType.number,
                    enmPropertyType.date,
                    enmPropertyType.datetime,
                    enmPropertyType.time,
                    enmPropertyType.string
                ]
            },
            3: {
                title: "بزرگتر از",
                types: [
                    enmPropertyType.number,
                    enmPropertyType.date,
                    enmPropertyType.datetime,
                    enmPropertyType.time,
                    enmPropertyType.string
                ]
            },
            4: {
                title: "شروع با", types: [
                    enmPropertyType.string
                ]
            },
            5: {
                title: "خاتمه با", types: [
                    enmPropertyType.string
                ]
            },
            6: {
                title: "شامل", types: [
                    enmPropertyType.string
                ]
            },
            7: {
                title: "کوچکتر یا مساوی با",
                types: [
                    enmPropertyType.number,
                    enmPropertyType.date,
                    enmPropertyType.datetime,
                    enmPropertyType.time,
                    enmPropertyType.string
                ]
            },
            8: {
                title: "بزرگتر یا مساوی با",
                types: [
                    enmPropertyType.number,
                    enmPropertyType.date,
                    enmPropertyType.datetime,
                    enmPropertyType.time,
                    enmPropertyType.string
                ]
            },
            9: {
                title: "شامل نباشد", types: [
                    enmPropertyType.string
                ]
            }
        };
    }
    getOperators(propertyType: enmPropertyType): any[] {
        let lst: any[] = [];
        for (var key in Core.operators) {
            let val = Core.operators[key].types.find(t => t === propertyType);
            if (val != null)
                lst.push({ key, value: Core.operators[key].title });
        };

        return lst;
    }
    newId(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    getPropertyName<T>(propertySelector: (obj: T) => void): string {
        let fn = propertySelector.toString();
        let ind1 = fn.indexOf('.') + 1;
        let chr = fn.indexOf(';') > -1 ? ';' : '}';
        let propname = fn.substr(ind1, (fn.indexOf(chr) > -1 ? fn.indexOf(chr) - ind1 : fn.length - ind1));
        return propname;
    }
    decode(message: string): any {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: message } });
    }
    errorNotification(message?: string | null) {
        if (message)
            notification.error({ message: this.decode(message), duration: 7, placement: 'bottomLeft' });
    }
    successNotification(message?: string | null) {
        if (message)
            notification.success({ message: this.decode(message), duration: 7, placement: 'bottomLeft' });
    }
    warningNotification(message?: string | null) {
        if (message)
            notification.warning({ message: this.decode(message), duration: 7, placement: 'bottomLeft' });
    }
    clone(obj: any): any {
        var cloneObj: any = {};
        for (var attribut in obj) {
            if (typeof obj[attribut] === "object") {
                cloneObj[attribut] = this.clone(obj[attribut]);
            } else {
                cloneObj[attribut] = obj[attribut];
            }
        }
        return cloneObj;
    }
    async callApi(options: ICallOptions): Promise<boolean> {
        let retry = false;
        let result: IResult | null = null;
        let headers: any = options.contentType !== false ? { 'content-type': 'application/json;charset=UTF-8' } : {};
        if (options.headers?.length) {
            for (let i = 0; i < options.headers.length; i++)
                headers[options.headers[i].key] = options.headers[i].value;
        }
        try {
            let response = await fetch("api/" + options.url, {
                method: 'POST',
                body: options.contentType !== false ? JSON.stringify(options.data) : options.data,
                headers
            });

            this.isTestEnvironment = response.headers.get('IsTestEnvironment') === "true";
            this.isDevelopement = response.headers.get('IsDevelopement') === "true";

            if (response.status === 429) {
                this.errorNotification('تعداد درخواست بیش از حد مجاز است');
            }
            else if (response.status === 503) {
                this.errorNotification('متأسفانه سرویس مورد نظر در دسترس نیست، لطفاً دقایقی دیگر تلاش نمایید');
            }
            else if (response.status === 500) {
                this.errorNotification('متأسفانه خطایی در اجرای سرویس رخ داده است');
            }
            else if (response.status === 200) {
                result = await response.json();
                options.onSuccess?.call(this, result!);
            }
            else  {
                retry = true;
            }
        }
        catch (e) {
            options.onError?.call(this, e);
        }

        if (retry) {
            const tryCount = (options.tryCount ?? 0) + 1;
            if (tryCount < 3) {
                options.tryCount = tryCount;
                return await this.callApi(options);
            }
            else {
                this.errorNotification('متأسفانه سرویس در دسترس نیست، لطفاً دقایقی دیگر تلاش نمایید');
            }
        }

        options.onComplete?.call(this);
        return !retry;
    }
    getBase64(file: any) {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
        });
    }
    persianToEnglish(s: string): string {
        return s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
    }
    isNationalCode(text?: any): boolean {
        text = text || '';
        text = this.persianToEnglish(text);
        if (isNaN(text)) {
            return false;
        } else if (text === "") {
            return false;
        } else if (text.length !== 10) {
            return false;
        } else {

            let firstChar = text[0];
            for (let i = 1; i <= text.length - 1; i++) {
                if (firstChar !== text[i])
                    break;
                if (firstChar === text[i] && i === text.length - 1)
                    return false;
            }

            let yy = 0;
            for (let i = 0; i < text.length - 1; i++) {
                let yv = text[i] * (text.length - i);
                yy += yv;
            }
            let r = yy % 11;
            let c = parseInt(text.charAt(9));
            if ((r === 0 && r === c) || (r === 1 && c === 1) || (r > 1 && c === 11 - r)) {
                return true;
            } else {
                return false
            }
        }
    }
    getUrl(path: string, params?: any) {
        let url = '';
        if (path) {
            let search = '';
            for (let k in params) {
                if (search === '')
                    search += '?';
                if (search !== '?')
                    search += '&';
                search += k + '=' + params[k];
            }
            url = encodeURIComponent(path + search);
        }
        return url;
    }
    async logError(referenceUrl: string, message: string, stack: string) {
        await this.callApi({ url: 'home/loguserinterfaceerror', data: { referenceUrl, message, stack } });
    }
    enumToArray(enm: any) {
        let map: { id: number; name: string }[] = [];
        for (var n in enm) {
            if (typeof enm[n] === 'number') {
                map.push({ id: enm[n] as any, name: n });
            }
        }
        return map;
    }
}

export const Core = new TCore();